/**
 * 整数分 → "$4.99"。价格是以分下发的（见 `app/services/pricing.rb` 的注释）。
 *
 * **全仓唯一的金额格式化器** —— 定价页与落地页共用。各写一份就是那段注释警告的
 * 同一类漂移：一边显示「$4.99」另一边显示「$5」，而两边都对不上 Paddle 实际扣的款。
 * `test/controllers/home_controller_test.rb` 里有一条守它唯一性的测试。
 */
export function money(cents: number, currency: string): string {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    // 499 要显示成 $4.99，3900 要显示成 $39（而不是 $39.00）。
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100)
}
